import React from 'react';
import PropTypes from 'prop-types';

import SubMenuGroup from './SubMenuGroup';
import SubMenuSingle from './SubMenuSingle';

export default function SubMenu({ items }) {
  if (!items || items.length === 0) {
    return null;
  }

  const types = items.map((item) => item.type);
  if (types.indexOf('custom') !== -1) {
    return (
      <SubMenuGroup items={items} />
    );
  }

  return (
    <SubMenuSingle items={items} />
  );
}

SubMenu.propTypes = {
  /**
   * Items of submenu navigator
   */
  items: PropTypes.array
};
